export const capitalize = word =>
  word && word.length ? `${word[0].toUpperCase()}${word.substr(1)}` : "";
